import { useMutation } from "@tanstack/react-query";
import { generateJobDescription } from "../../api/ai_api";

export const useGenerateJd = ({ onSuccess, onError } = {}) => {
  return useMutation({
    mutationFn: generateJobDescription,
    onSuccess,
    onError
  });
};

export default useGenerateJd;
